import dayjs from 'dayjs'
import {
  COMPLETED_HEALTH_HISTORY,
  PROMO_PERIOD_DAYS,
  REWARD_PERIOD_DAYS,
  TASKS_REQUIRED_TO_MVP,
  YEARS_TO_EXPIRE_HEALTH_HISTORY,
} from '../consts/OnBoardingConsts'
import { getIsHmoMember } from './hmoUtils'

export const getNumberTasksCompletedInPromoPeriod = (
  patientTasks,
  promoPeriodDateExpire
) => {
  return patientTasks?.filter(
    task =>
      task.is_completed &&
      dayjs(task.completed_at)?.format('YYYY-MM-DD') <=
        dayjs(promoPeriodDateExpire)?.format('YYYY-MM-DD')
  ).length
}

export const getNumberTasksCompleted = patientTasks => {
  return patientTasks?.filter(task => task.is_completed).length
}

// get the last date of the completed tasks
export const getLastCompletedAt = userDetails => {
  const completedTasks = userDetails?.hmo_data?.on_boarding_tasks
    .filter(task => task?.is_completed)
    .sort((a, b) => new Date(b?.completed_at) - new Date(a?.completed_at))
  return completedTasks?.[0]?.completed_at
}

export const getMvpDate = userDetails => {
  return new Date(getLastCompletedAt(userDetails)).toLocaleDateString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
  })
}

export const isTaskCompleted = (patientTasks, task) => {
  // if the task is COMPLETED_HEALTH_HISTORY, check if the user completed the task and the task is still valid (1 year since the task was completed)
  if (task === COMPLETED_HEALTH_HISTORY.name) {
    return (
      patientTasks?.filter(
        currTask =>
          task === currTask?.task &&
          currTask?.is_completed &&
          new Date(currTask?.completed_at).setFullYear(
            new Date(currTask?.completed_at).getFullYear() +
              YEARS_TO_EXPIRE_HEALTH_HISTORY
          ) > new Date()
      ).length > 0
    )
  }
  return (
    patientTasks?.filter(
      currTask => task === currTask?.task && currTask?.is_completed
    ).length > 0
  )
}

export const isPatientMvp = userDetails => {
  return (
    getNumberTasksCompleted(userDetails?.hmo_data?.on_boarding_tasks) ===
    TASKS_REQUIRED_TO_MVP
  )
}

export const getPromoExpireDate = enrollmentDate => {
  var promoPeriodDateExpire = new Date(enrollmentDate)
  promoPeriodDateExpire.setDate(
    promoPeriodDateExpire.getDate() + PROMO_PERIOD_DAYS
  )
  return promoPeriodDateExpire
}

export const getDaysLeftUntilPromoExpire = promoPeriodDateExpire => {
  const now = new Date()
  const oneDay = 24 * 60 * 60 * 1000 // hours*minutes*seconds*milliseconds
  return Math.ceil((promoPeriodDateExpire.getTime() - now) / oneDay)
}

export const getRewardExpireDate = promoPeriodDateExpire => {
  var rewardDateExpire = new Date(promoPeriodDateExpire)
  rewardDateExpire.setDate(rewardDateExpire.getDate() + REWARD_PERIOD_DAYS)
  return rewardDateExpire
}

// if the user is HMO member and the communication preferences are not completed, redirect to communication preferences
export const checkIfNeedToRedirectToCommunicationPerferences = userDetails => {
  return getIsHmoMember(userDetails) && !userDetails?.isCommunicationPreferences
}

export const checkIfNeedToRedirectToSecretQuestions = userDetails => {
  return getIsHmoMember(userDetails) && !userDetails?.isSecretQuestions
}

// if completed 2 tasks in promo period - show for 7 days from last completed at.
// If 1 completed in promo period and now is after the promo show for 7 days from promo end date
// Else don’t show)
export const checkIfNeedGiftCardMsg = (userDetails, completedTasks) => {
  var lastDayToShowGiftCardMsg = new Date()
  if (completedTasks === TASKS_REQUIRED_TO_MVP) {
    var lastCompletedAt = getLastCompletedAt(userDetails)
    lastDayToShowGiftCardMsg = new Date(lastCompletedAt)
    lastDayToShowGiftCardMsg.setDate(
      lastDayToShowGiftCardMsg.getDate() + REWARD_PERIOD_DAYS
    )
    if (lastDayToShowGiftCardMsg >= new Date()) {
      return true
    }
  } else if (completedTasks < TASKS_REQUIRED_TO_MVP && completedTasks > 0) {
    var promoPeriodDateExpire = getPromoExpireDate(
      userDetails?.hmo_data?.enrollment_date
    )
    if (promoPeriodDateExpire <= new Date()) {
      lastDayToShowGiftCardMsg = new Date(promoPeriodDateExpire)
      lastDayToShowGiftCardMsg.setDate(
        lastDayToShowGiftCardMsg.getDate() + REWARD_PERIOD_DAYS
      )
      if (lastDayToShowGiftCardMsg >= new Date()) {
        return true
      }
    }
  }
  return false
}
